import {
  Sun,
  CloudSun,
  Cloud,
  CloudFog,
  CloudDrizzle,
  CloudRain,
  CloudSnow,
  CloudLightning,
  type LucideIcon,
} from "lucide-react";

export interface WmoInfo {
  label: string;
  icon: LucideIcon;
  color: string;
}

export function wmoInfo(code: number): WmoInfo {
  if (code === 0) return { label: "Clear sky", icon: Sun, color: "text-amber-300" };
  if (code === 1) return { label: "Mainly clear", icon: Sun, color: "text-amber-300/90" };
  if (code === 2) return { label: "Partly cloudy", icon: CloudSun, color: "text-sky-300" };
  if (code === 3) return { label: "Overcast", icon: Cloud, color: "text-slate-300" };
  if (code === 45 || code === 48) return { label: code === 45 ? "Fog" : "Rime fog", icon: CloudFog, color: "text-slate-400" };
  if (code >= 51 && code <= 57) return { label: "Drizzle", icon: CloudDrizzle, color: "text-sky-400" };
  if (code >= 61 && code <= 67) return { label: "Rain", icon: CloudRain, color: "text-sky-400" };
  if (code >= 71 && code <= 77) return { label: "Snow", icon: CloudSnow, color: "text-slate-300" };
  if (code >= 80 && code <= 82) return { label: "Rain showers", icon: CloudRain, color: "text-sky-400" };
  if (code >= 85 && code <= 86) return { label: "Snow showers", icon: CloudSnow, color: "text-slate-300" };
  if (code >= 95 && code <= 99) return { label: "Thunderstorm", icon: CloudLightning, color: "text-amber-400" };
  return { label: "Unknown", icon: Cloud, color: "text-slate-400" };
}
